import { IRootState } from "../../app/types/rootReducers.t";
import { createSelector } from "reselect";
import {
    isClientAndroid,
    isClientIOS,
    isClientSafari
} from "../../components/ClientInfo/ClientInfo";
import { LOCAL_STORAGE_KEYS } from "../../app/appConstants";
import { getAppModeSelector } from "../../app/appSelectors";

const pwaSelector = (state: IRootState) => state.pwa;

export const getPwaInstallPromptEventSelector = createSelector(
    pwaSelector, pwaState => pwaState.installPromptEvent,
);

export const getIsCanInstallPwaSelector = createSelector(
    [pwaSelector, getAppModeSelector], (pwaState, appMode) =>
        appMode === 'web' && pwaState.isPwaAllowed && (
            (isClientAndroid && !!pwaState.installPromptEvent)
            ||
            (isClientIOS && isClientSafari && !localStorage.getItem(LOCAL_STORAGE_KEYS.PWA_OPENED_AT))
        ),
    );

export const getPwaStateSelector = createSelector(
    pwaSelector, pwaState => pwaState,
);
